export default "__VITE_ASSET__8f8bd3ec__"